var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitePlayersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5122,
    r: 16,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 14.2478 19.1095)",
    fill: "#180F24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 2.74286,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 13.3337 20.0236)",
    fill: "#180F24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 2.74286,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 20.6484 20.0236)",
    fill: "#180F24"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 2.74286,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 25.2197 17.2806)",
    fill: "#180F24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93359,
    y: 17.2806,
    width: 1.82857,
    height: 2.74286,
    fill: "#180F24"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48571,
    height: 1.82857,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 18.8193 18.1947)",
    fill: "#180F24"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.65714,
    height: 1.82857,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 23.3906 15.4521)",
    fill: "#180F24"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7627,
    y: 15.4521,
    width: 3.65714,
    height: 1.82857,
    fill: "#180F24"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 19.7341 19.1095)",
    fill: "#180F24"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 24.3049 16.3666)",
    fill: "#180F24"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.8479,
    y: 16.3666,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2478,
    y: 13.624,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8193,
    y: 10.8815,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 0 0 1 13.3337 10.8815)",
    fill: "#180F24"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1626,
    y: 12.7096,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7341,
    y: 9.9668,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 0 0 1 12.4194 9.9668)",
    fill: "#180F24"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0767,
    y: 13.624,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6484,
    y: 10.8815,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 0 0 1 11.5049 10.8815)",
    fill: "#180F24"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1626,
    y: 14.5381,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7341,
    y: 11.7949,
    width: 1.82857,
    height: 1.82857,
    fill: "#180F24"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 1.82857,
    height: 1.82857,
    transform: "matrix(-1 0 0 1 12.4194 11.7949)",
    fill: "#180F24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlayersIcon);
export default __webpack_public_path__ + "static/media/white-players-icon.288dd8c9782b374f95ccf11703437e78.svg";
export { ForwardRef as ReactComponent };